import React from "react";
import { AlertTriangle, Phone, MapPin, ArrowUpRight } from "lucide-react";
import { afterHours } from "../mock";

export default function AfterHours() {
  return (
    <section className="relative px-4 md:px-8 pb-20">
      <div className="mx-auto max-w-[1400px] rounded-[32px] bg-gradient-to-br from-[#c92f2f] to-[#a11e1e] text-white overflow-hidden">
        <div className="relative grid grid-cols-1 lg:grid-cols-[1fr_auto_auto] gap-6 lg:gap-8 items-center p-8 md:p-10">
          <div className="flex items-start gap-4 max-w-2xl">
            <div className="shrink-0 w-12 h-12 rounded-full bg-white/15 grid place-items-center">
              <AlertTriangle className="w-6 h-6 text-white" />
            </div>
            <div>
              <div className="text-xs font-semibold uppercase tracking-widest text-white/70 mb-1">After hours</div>
              <div className="text-xl md:text-2xl font-bold leading-tight">{afterHours.headline}</div>
              <p className="text-white/85 text-sm mt-2 leading-relaxed">{afterHours.desc}</p>
            </div>
          </div>

          <a
            href={afterHours.hospital.mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-4 bg-white/10 hover:bg-white/15 border border-white/20 rounded-2xl p-5 min-w-[280px] transition-colors"
          >
            <MapPin className="w-5 h-5 shrink-0" />
            <div className="flex-1">
              <div className="font-bold text-white leading-tight">{afterHours.hospital.name}</div>
              <div className="text-white/75 text-xs mt-1">{afterHours.hospital.address}</div>
              <div className="text-white/90 text-sm mt-1 font-semibold">{afterHours.hospital.phone}</div>
            </div>
            <ArrowUpRight className="w-4 h-4 text-white/70 shrink-0" />
          </a>

          <a
            href="tel:000"
            className="flex items-center gap-3 bg-white text-[#a11e1e] rounded-2xl px-5 py-4 hover:bg-white/95 min-w-[220px]"
          >
            <div className="w-11 h-11 rounded-full bg-[#a11e1e] grid place-items-center text-white shrink-0">
              <Phone className="w-5 h-5" />
            </div>
            <div>
              <div className="text-xs uppercase tracking-widest font-semibold text-[#a11e1e]/70">Emergency</div>
              <div className="text-2xl font-extrabold leading-none mt-0.5">Call {afterHours.emergency.number}</div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
